export default {
    quotaExceededTitle: 'Límite de plan alcanzado',
    quotaExceededMessage: 'Has alcanzado el límite de tu plan para este recurso.',
    quotaHardCapMessage: 'Se alcanzó un límite de infraestructura para este recurso. No es posible ampliarlo con upgrade ni add-ons.',
    quotaCtaUpgrade: '¿Deseas ir a Mi suscripción para solicitar un upgrade de plan?',
    quotaCtaUpgradeOrAddon: '¿Deseas ir a Mi suscripción para solicitar un upgrade o contratar un add-on?',
    quotaTitle: 'Cuotas y consumo',
    quotaMenu: 'Cuotas',
    quotaSubtitle: 'Consulta el consumo de un tenant frente a sus límites efectivos',
    selectTenant: 'Selecciona un tenant',
    quotaTenant: 'Tenant',
    cyclePeriod: 'Período del ciclo',
    cycleRange: 'Vigencia',
    colModule: 'Módulo',
    colAttribute: 'Atributo',
    colCurrent: 'Consumo',
    colPlanLimit: 'Límite del plan',
    colAddonBonus: 'Add-ons',
    colEffective: 'Límite efectivo',
    colUsage: 'Uso',
    nearLimit: 'Cerca del límite',
    atLimit: 'Límite alcanzado',
    perParentLimit: 'Límite por elemento padre',
    exceeded: 'Excedido',
    resetQuota: 'Reiniciar consumo',
    confirmReset: '¿Reiniciar el consumo de este tenant para el ciclo actual?',
    resetSuccess: 'Consumo reiniciado correctamente',
    resetError: 'Error al reiniciar el consumo',
    quotaLoadError: 'Error al cargar el consumo del tenant',
    noUsageSelected: 'Selecciona un tenant para ver su consumo',
    noUsageData: 'No hay datos de consumo para este tenant',
    query: 'Consultar',
};
